import React, { Component } from 'react';
import {
  TextInput,
  Button,
  Table,
  Toggle,
  Accordion,
  AccordionItem,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  FormLabel,
  RadioButtonGroup,
  FormGroup,
  RadioButton,
  TextArea,
  TableToolbar,
  DropdownSkeleton,
} from 'carbon-components-react';
import { Checkmark24, Add16, Edit16, Delete16 } from '@carbon/icons-react';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import _sortBy from 'lodash/sortBy';
import { Section } from '../../lib/react-scroll-section/src/index';
import { Menu, Item } from '../../helpers/scrolling/ScrollingMenuItem';
import '../../scss/custom.scss';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  DateFormat,
} from '../../helpers/Constants';
import { api, dynamic } from '../../helpers/api/api';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import { IncidentEventModal } from './IncidentEventModal';
import { WitnessPeopleModal } from './WitnessPeopleModal';
import { TeamMemberModal } from './TeamMemberModal';
import { IncidentAttachment } from './IncidentAttachment';
import { IsEditable } from '../../helpers/authorization/Policies';
import { InjuredPersonModal } from './InjuredPersonModal';
import DateTimePicker from '../../helpers/DateTimePicker';

const incidentTabInvestigationModel = {
  id: null,
  sourceAccident: null, // ''

  spillLakeUM: null,
  spillLakeNumericValue: null, // 0
  spillRiverUM: null,
  spillRiverNumericValue: null, // 0
  spillSeaUM: null,
  spillSeaNumericValue: null, // 0
  spillSoilUM: null,
  spillSoilNumericValue: null, // 0

  spillSubstanceReleased: null, // ''

  uncontrolledReleaseLakeUM: null,
  uncontrolledReleaseLakeNumericValue: null, // 0
  uncontrolledReleaseRiverUM: null,
  uncontrolledReleaseRiverNumericValue: null, // 0
  uncontrolledReleaseSeaUM: null,
  uncontrolledReleaseSeaNumericValue: null, // 0
  uncontrolledReleaseSoilUM: null,
  uncontrolledReleaseSoilNumericValue: null, // 0

  uncontrolledReleaseSubstanceReleased: null, // ''
  uncontrolledReleaseDescription: null, // ''

  spillDescription: null, // ''
  isUsedSpillKit: null, // false
  isInPlaceProcedure: null, // false
  airPollUM: null,
  airPollSubstanceReleased: null, // ''
  airPollQuantityReleased: null, // 0
  isFloraImpacted: null, // false
  isFaunaImpacted: null, // false

  incidentEvents: null, // [IncidentEvent]

  idWorkArea: null, // guid
  idWorkProcess: null, // guid
  idEquipment: null, // guid
  idWorkProcessType: null, // solo DTO
  idWorkAreaType: null, // solo DTO
  idEquipmentType: null, // solo DTO

  // ---AT BUG 2844
  specifyOtherWorkArea: null,
  specifyOtherWorkProcess: null,
  specifyOtherEquipment: null,
  //---

  light: null,
  lightOrigin: null,
  wheather: null,
  sea: null,
  temperature: null,
  temperatureType: null,
  windSpeed: null,

  noWitness: null,
  witnessPeople: null, // [IncidentWitnessPerson],
  investigationTeamMembers: null, // [InvestigationTeamMember]
  attachment: null, // [Attachment]

  // investigationCriticalFactors: null,
  // lessonLearned: null,
  isSpill: false,
  isUncontrolledRelease: false,
  isFloraFaunaDamage: false,
  isAirPollutio: false,
  isOther: false,

  idAssetDamageType: false,
  idToDelete: false,
  injuredPeople: [],
  certification: null,
  safetyDeviceRemoved: null,
  safetyCritial: null,
  cmms: null,
};
const uncontrolledCategories = ['uncontrolledReleaseRiverUM', 'uncontrolledReleaseRiverNumericValue', 'uncontrolledReleaseLakeUM', 'uncontrolledReleaseLakeNumericValue', 'uncontrolledReleaseSeaUM','uncontrolledReleaseSeaNumericValue', 'uncontrolledReleaseSoilUM' , 'uncontrolledReleaseSoilNumericValue' , 'uncontrolledReleaseContainedNumericValue']
const spillCategories = ['spillRiverUM', 'spillRiverNumericValue', 'spillLakeUM', 'spillLakeNumericValue', 'spillSeaUM','spillSeaNumericValue', 'spillSoilUM' , 'spillSoilNumericValue' , 'spillContainedNumericValue']
const spillOrUncontrolledDictionary = {'uncontrolledReleaseRiverUM':'uncontrolledReleaseRiverNumericValue', 'uncontrolledReleaseLakeUM':'uncontrolledReleaseLakeNumericValue', 'uncontrolledReleaseSeaUM':'uncontrolledReleaseSeaNumericValue','uncontrolledReleaseSoilUM':'uncontrolledReleaseSoilNumericValue', 'spillRiverUM':'spillRiverNumericValue', 'spillLakeUM':'spillLakeNumericValue', 'spillSeaUM':'spillSeaNumericValue','spillSoilUM':'spillSoilNumericValue'}
export default class IncidentTabInvestigation extends Component {
  initialState = (props) => {
    const initialState = {
      keyModal: `modal_${new Date().getTime()}`,
      editModel: null,
      isEditModal: false,
      isOpenModal: false,
      isOpenDeleteModal: false,
      isDeleting: false,
      idToDelete: null,

      keyModalWitness: `modalWitness_${new Date().getTime()}`,
      editModelWitness: null,
      isEditModalWitness: false,
      isOpenModalWitness: false,
      idToDeleteWitness: null,

      keyModalTeamMember: `modalTeamMember_${new Date().getTime()}`,
      editModelTeamMember: null,
      isEditModalTeamMember: false,
      isOpenModalTeamMember: false,
      idToDeleteTeamMember: null,

      incidentModel: {
        ...incidentTabInvestigationModel,
      },
      appAccidentSource: null,
      appMeasureUnit: null,

      appWorkProcessType: null,
      appWorkAreaType: null,
      appEquipmentType: null,
      appWorkProcess: null,
      appWorkArea: null,
      appEquipment: null,
      appSea: ['Calm', 'Slight', 'Moderate', 'Rough', 'Very Rough', 'High'],
      isDisabled: true,
      appBodyPart: [],
      appInjuryClass: [],
      appInjurySource: [],
      appShiftDuration: [],
      appContractType: [],
      assetdamagetype: [],
      isInNewInjuredPerson: false,
      isInjuredPersonsComplete: true,
    };
    if (props.incidentEditModel) {
      initialState.incidentModel = { ...props.incidentEditModel };
      initialState.isDisabled = !IsEditable(
        'Incident',
        'Reporting',
        props.user,
        props.incidentEditModel.status.id,
        'Investigation',
        props.incidentEditModel
      );
    }
    return initialState;
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
    this.updateState = this.updateState.bind(this);
    this.handleChangeCombo = this.handleChangeCombo.bind(this);
    this.state = {
      ...this.initialState(props),
    };
 }

  componentDidMount() {
    this.getContractType();
    this.getShiftDuration();
    this.getInjurySource();
    this.getAssetdamagetype();
    this.getInjuryClass();
    this.getBodyPart();
    api
      .getAll('/incident/substancereleased')
      .then((response) => {
        const data = response.data.map((elem) => elem.name);
        this.setState({
          substanceReleased: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EQUIPMENT, apioperation.GET)
        );
      })
      .finally(() => {});
    api
      .getAll('/incident/impacton')
      .then((response) => {
        const data = response.data.map((elem) => elem.name);
        this.setState({
          impactOn: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EQUIPMENT, apioperation.GET)
        );
      })
      .finally(() => {});
    dynamic
      .getAll('accidentsource', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appAccidentSource: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ACCIDENTSOURCE, apioperation.GET)
        );
      })
      .finally(() => {});

    dynamic
      .getAll('measureunit', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appMeasureUnit: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.MEASUREUNIT, apioperation.GET)
        );
      })
      .finally(() => {});

    Promise.all([
      dynamic
        .getAll('workprocess', { params: { page: 0, parent: 'all' } })
        .then((response) => {
          const data = response.data.itemList;
          const type = _sortBy(
            data.filter((el) => el.idParent == null),
            'name'
          );
          this.setState({
            appAllWorkProcess: data,
            appWorkProcessType: type,
          });
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.WORKPROCESS, apioperation.GET)
          );
        })
        .finally(() => {}),

      dynamic
        .getAll('workarea', { params: { page: 0, parent: 'all' } })
        .then((response) => {
          const data = response.data.itemList;
          const type = _sortBy(
            data.filter((el) => el.idParent == null),
            'name'
          );
          this.setState({
            appAllWorkArea: data,
            appWorkAreaType: type,
          });
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.WORKAREA, apioperation.GET)
          );
        })
        .finally(() => {}),

      dynamic
        .getAll('equipment', { params: { page: 0, parent: 'all' } })
        .then((response) => {
          const data = response.data.itemList;
          const type = _sortBy(
            data.filter((el) => el.idParent == null),
            'name'
          );
          this.setState({
            appAllEquipment: data,
            appEquipmentType: type,
          });
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.EQUIPMENT, apioperation.GET)
          );
        })
        .finally(() => {}),
    ])
      .then((response) => {
        if (this.props.incidentEditModel) {
          // loading valori combo calcolate,
          if (this.state.incidentModel.idWorkProcessType) {
            this.getWorkProcess(this.state.incidentModel.idWorkProcessType);
          }
          if (this.state.incidentModel.idWorkAreaType) {
            this.getWorkArea(this.state.incidentModel.idWorkAreaType);
          }
          if (this.state.incidentModel.idEquipmentType) {
            this.getEquipment(this.state.incidentModel.idEquipmentType);
          }
        }
      })
      .catch((error) => {
        console.log({ error });
      });
  }

  getBodyPart() {
    dynamic
      .getAll('bodypart', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appBodyPart: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.BODYPART, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getInjuryClass() {
    dynamic
      .getAll('injuryclass', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appInjuryClass: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INJURYCLASS, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getInjurySource() {
    dynamic
      .getAll('injurysource', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appInjurySource: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INJURYSOURCE, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getAssetdamagetype() {
    dynamic
      .getAll('assetdamagetype', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          assetdamagetype: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INJURYSOURCE, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getContractType() {
    dynamic
      .getAll('contracttype', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appContractType: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CONTRACTTYPE, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getShiftDuration() {
    dynamic
      .getAll('shiftduration', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appShiftDuration: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.SHIFDURATION, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getWorkProcess(parent) {
    try {
      const data = _sortBy(
        (this.state.appAllWorkProcess || []).filter((el) => el.idParent == parent),
        'name'
      );
      this.setState({
        appWorkProcess: data,
      });
    } catch {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        `Error filtering ${entitiesLabels.WORKPROCESS}`
      );
    }
    // dynamic.getAll('workprocess', { params: { page: 0, parent: parent, } })
    //     .then(response => {
    //         var data = response.data.itemList;
    //         this.setState({
    //             appWorkProcess: data
    //         });
    //     }).catch(error => {
    //         showNotification.error(getError(error, entitiesLabels.WORKPROCESS, apioperation.GET));

    //     }).finally(() => {

    //     });
  }

  getWorkArea(parent) {
    try {
      const data = _sortBy(
        (this.state.appAllWorkArea || []).filter((el) => el.idParent == parent),
        'name'
      );
      this.setState({
        appWorkArea: data,
      });
    } catch {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        `Error filtering ${entitiesLabels.WORKAREA}`
      );
    }
    // dynamic.getAll('workarea', { params: { page: 0, parent: parent, } })
    //     .then(response => {
    //         var data = response.data.itemList;
    //         this.setState({
    //             appWorkArea: data
    //         });
    //     }).catch(error => {
    //         showNotification.error(getError(error, entitiesLabels.WORKAREA, apioperation.GET));

    //     }).finally(() => {

    //     });
  }

  getEquipment(parent) {
    try {
      const data = _sortBy(
        (this.state.appAllEquipment || []).filter((el) => el.idParent == parent),
        'name'
      );
      this.setState({
        appEquipment: data,
      });
    } catch {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        `Error filtering ${entitiesLabels.EQUIPMENT}`
      );
    }
    // dynamic.getAll('equipment', { params: { page: 0, parent: parent, } })
    //     .then(response => {
    //         var data = response.data.itemList;
    //         this.setState({
    //             appEquipment: data
    //         });
    //     }).catch(error => {
    //         showNotification.error(getError(error, entitiesLabels.EQUIPMENT, apioperation.GET));

    //     }).finally(() => {

    //     });
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  updateStateDP = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy.incidentModel.lastDateInspection = inputValue;
    this.setState(statusCopy);
  };

  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = el.target.alt;
    this.updateState(inputName, inputValue, objName);
  };

  handleToggle = (value, id) => {
    // onchange toggle widget
    this.updateState(id, value, 'incidentModel');
  };
  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id || selectedItem : null;

    const statusCopy = { ...this.state[objName] };
    statusCopy[inputName] = inputValue;
    for (const [key, value] of Object.entries(spillOrUncontrolledDictionary)) { //Se un UM cambia setto a null i NumericValue precedentemente settati 
      if(key==inputName)
      statusCopy[value] = null;
    }
    if(inputName == 'spillContainedUM') { //Se Spill contained viene valorizzato setto a null tutti i valori di Lake, River, Sea e Soil
      spillCategories.forEach(element => {
        statusCopy[element] = null;
      });
    }

    if(inputName == 'uncontrolledReleaseContainedUM') {//Se uncontrolled contained viene valorizzato setto a null tutti i valori di Lake, River, Sea e Soil
      uncontrolledCategories.forEach(element => {
        statusCopy[element] = null;
      });
      }

    this.setState({ [objName]: statusCopy });
  };

  handleChangeRadio = (value, id, event) => {
    if (value == 'true') {
      value = true;
    } else if (value == 'false') {
      value = false;
    } else if (value == 'null') {
      value = null;
    }

    this.updateState(event.target.name, value, event.target.alt);
  };

  addNewPerson = () => {
    this.setState({ keyModal: `modal_${new Date().getTime()}` });
    this.setState({ isEditModalIJ: false, isOpenModalIJ: true, editModelIJ: null });
  };

  getInjuryTypeName = (id) => {
    const element = this.props.appInjuryType.find((el) => el.id == id);
    return element ? element.name : '';
  };

  editModal = (id) => {
    this.setState({ keyModal: `modal_${new Date().getTime()}` });
    const item = this.state.incidentModel.injuredPeople.find((el) => el.id == id);
    this.setState({ editModelIJ: item, isEditModalIJ: true, isOpenModalIJ: true });
  };

  confirmDeleteInjPerson = (id) => {
    this.setState({
      idInjurePerson: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  toggleModal = (open) => {
    this.setState({ isOpenModalIJ: open });
  };

  deleteItemInjuredPerson = () => {
    const id = this.state.idInjurePerson;
    this.setState({
      isDeleting: true,
    });

    const statusCopy = { ...this.state.incidentModel };
    const deleteI = statusCopy.injuredPeople.filter((el) => el.id == id);
    statusCopy.injuredPeople = statusCopy.injuredPeople.filter((el) => el.id !== id);

  
  this.saveInjuredPerson(deleteI);
  

    this.setState({
      incidentModel: statusCopy,
      isDeleting: false,
      isOpenDeleteModal: false,
    });
  };

  
  saveInjuredPerson = (item) => {
    const datiForm = item[0];
    api
      .put('/incident/', datiForm, `${datiForm.idIncident}/investigation/injured`)
      .then((response) => {
        if (response.status == 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.INJUREDPEROSN, apioperation.PUT)
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INJUREDPEROSN, apioperation.POST)
        );
      })
      .finally(() => {
      });
};

  handleSaveModal = (data) => {
    try {
      if (data == null) return;

      const oldinjuredPeople = this.state.incidentModel.injuredPeople || [];

      if (this.state.isEditModalIJ) {
        // edit
        const { id } = data;
        const indexElement = oldinjuredPeople.findIndex((el) => el.id == id);
        if (indexElement > -1) {
          const newinjuredPeople = [...oldinjuredPeople];
          newinjuredPeople[indexElement] = data;
          this.updateState('injuredPeople', newinjuredPeople, 'incidentModel');
        } else {
          showNotification.error();
        }
      } else {
        // insert
        data.idIncident = this.props.incidentEditModel.id;
        data.id = uuid(); // id IncidentInjuredPerson
        data.toSave = true; // solo gli injured appena creati possono essere modificati
        const newinjuredPeople = oldinjuredPeople.concat([data]);
        this.updateState('injuredPeople', newinjuredPeople, 'incidentModel');
      }

      this.setState({ isOpenModalIJ: false });
    } catch (error) {
      showNotification.error();
    }
  };

  handleChangeComboType = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;

    const statusCopy = { ...this.state[objName] };
    statusCopy[inputName] = inputValue;

    if (inputName == 'idWorkProcessType') {
      statusCopy.idWorkProcess = null;
    }

    if (inputName == 'idWorkAreaType') {
      statusCopy.idWorkArea = null;
    }

    if (inputName == 'idEquipmentType') {
      statusCopy.idEquipment = null;
    }

    this.setState({ [objName]: statusCopy }, () => {
      this.loadRelatedProperties(inputName, inputValue, selectedItem);
    });
  };

  loadRelatedProperties = (inputName, inputValue, selectedItem) => {
    if (inputName == 'idWorkProcessType') {
      if (inputValue) this.getWorkProcess(inputValue);
      else {
        this.setState({
          appWorkProcess: null,
        });
      }
    }

    if (inputName == 'idWorkAreaType') {
      if (inputValue) this.getWorkArea(inputValue);
      else {
        this.setState({
          appWorkArea: null,
        });
      }
    }

    if (inputName == 'idEquipmentType') {
      if (inputValue) this.getEquipment(inputValue);
      else {
        this.setState({
          appEquipment: null,
        });
      }
    }
  };

  selectTab = (index) => {
    this.props.selectTab(index);
  };

  saveTabInvestigation = () => {
    if (this.state.incidentModel.noInjured == null)
      this.updateState('noInjured', !this.props.realOutcomeHarm, 'incidentModel');

    if ((this.validator.allValid() && this.state.isInjuredPersonsComplete === true) ||
    (this.validator.allValid() && this.state.isDeleting === true))  {
      this.props.isSubmitted(true);

      const datiForm = this.state.incidentModel;

      api
        .put('/incident/', datiForm, `${datiForm.id}/investigation`)
        .then((response) => {
          if (response.status == 200) {
            showNotification.success(
              `${entitiesLabels.SUCCESS}`,
              this.state.incidentModel.id != null
                ? `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${
                    datiForm.incidentReportId
                  } ${getSuccess('investigation', apioperation.PUT)}`
                : getSuccess(entitiesLabels.INCIDENT, apioperation.POST)
            );
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.INCIDENT, apioperation.POST)
          );
        })
        .finally(() => {
          this.props.isSubmitted(false);
        });

      this.props.updateCacheIncidentModel(datiForm, 'tabInvestigation');
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.INCIDENT} required fields are missing  `
      );
      if (!this.state.isInjuredPersonsComplete){
        showNotification.warning(
          `${entitiesLabels.WARNING}`,
          `${entitiesLabels.INJUREDPEROSN} : Injured Personnel details - required fields are missing `
        );}
      this.forceUpdate();
    }
  };

  /** ************Time line********************* */
  toggleEventModal = (open) => {
    this.setState({ isOpenModal: open });
  };

  addNewEvent = () => {
    this.setState({ keyModal: `modal_${new Date().getTime()}` });
    this.setState({ isEditModal: false, isOpenModal: true, editModel: null });
  };

  editEventModal = (id) => {
    this.setState({ keyModal: `modal_${new Date().getTime()}` });
    const item = this.state.incidentModel.incidentEvents.find((el) => el.id == id);
    this.setState({ editModel: item, isEditModal: true, isOpenModal: true });
  };

  handleEventSaveModal = (data) => {
    try {
      if (data == null) return;

      const oldincidentEvents = this.state.incidentModel.incidentEvents || [];

      if (this.state.isEditModal) {
        // edit
        const { id } = data;
        const indexElement = oldincidentEvents.findIndex((el) => el.id == id);
        if (indexElement > -1) {
          const newincidentEvents = [...oldincidentEvents];
          newincidentEvents[indexElement] = data;
          this.updateState('incidentEvents', newincidentEvents, 'incidentModel');
        } else {
          showNotification.error();
        }
      } else {
        // insert
        data.idIncident = this.props.incidentEditModel.id;
        data.id = uuid(); // id IncidentEvent

        const newincidentEvents = oldincidentEvents.concat([data]);
        this.updateState('incidentEvents', newincidentEvents, 'incidentModel');
      }

      this.setState({ isOpenModal: false });
    } catch (error) {
      showNotification.error();
    }
  };

  confirmDelete = (id) => {
    this.setState({
      idToDelete: id,
      idToDeleteWitness: null,
      idToDeleteTeamMember: null,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItem = () => {
    const id = this.state.idToDelete;
    this.setState({
      isDeleting: true,
    });

    const statusCopy = { ...this.state.incidentModel };
    statusCopy.incidentEvents = statusCopy.incidentEvents.filter((el) => el.id !== id);

    this.setState({
      incidentModel: statusCopy,
      isDeleting: false,
      isOpenDeleteModal: false,
    });
  };

  /** ************Fine Time line********************* */

  /** ************Witness********************* */

  toggleWitnessModal = (open) => {
    this.setState({ isOpenModalWitness: open });
  };

  addWitness = () => {
    this.setState({ keyModalWitness: `modalWitness_${new Date().getTime()}` });
    this.setState({ isEditModalWitness: false, isOpenModalWitness: true, editModelWitness: null });
  };

  editWitnessModal = (id) => {
    this.setState({ keyModalWitness: `modalWitness_${new Date().getTime()}` });
    const item = this.state.incidentModel.witnessPeople.find((el) => el.id == id);
    this.setState({ editModelWitness: item, isEditModalWitness: true, isOpenModalWitness: true });
  };

  handleWitnessSaveModal = (data) => {
    try {
      if (data == null) return;

      const oldwitnessPeople = this.state.incidentModel.witnessPeople || [];

      if (this.state.isEditModalWitness) {
        // edit
        const { id } = data;
        const indexElement = oldwitnessPeople.findIndex((el) => el.id == id);
        if (indexElement > -1) {
          const newwitnessPeople = [...oldwitnessPeople];
          newwitnessPeople[indexElement] = data;
          this.updateState('witnessPeople', newwitnessPeople, 'incidentModel');
        } else {
          showNotification.error();
        }
      } else {
        // insert
        data.idIncident = this.props.incidentEditModel.id;
        data.id = uuid(); // id IncidentInjuredPerson
        const newid = uuid(); // id InvolvedPerson
        data.idInvolvedPerson = newid;
        data.involvedPerson.id = newid;

        const newwitnessPeople = oldwitnessPeople.concat([data]);
        this.updateState('witnessPeople', newwitnessPeople, 'incidentModel');
      }

      this.setState({ isOpenModalWitness: false });
    } catch (error) {
      showNotification.error();
    }
  };

  confirmWitnessDelete = (id) => {
    this.setState({
      idToDelete: null,
      idToDeleteWitness: id,
      idToDeleteTeamMember: null,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  deleteItemWitness = () => {
    const id = this.state.idToDeleteWitness;
    this.setState({
      isDeleting: true,
    });

    const statusCopy = { ...this.state.incidentModel };
    statusCopy.witnessPeople = statusCopy.witnessPeople.filter((el) => el.id !== id);

    this.setState({
      incidentModel: statusCopy,
      isDeleting: false,
      isOpenDeleteModal: false,
    });
  };

  /** ************Fine Witness********************* */
  /** ************TeamMember********************* */

  toggleTeamMemberModal = (open) => {
    this.setState({ isOpenModalTeamMember: open });
  };

  addTeamMember = () => {
    this.setState({ keyModalTeamMember: `modalTeamMember_${new Date().getTime()}` });
    this.setState({
      isEditModalTeamMember: false,
      isOpenModalTeamMember: true,
      editModelTeamMember: null,
    });
  };

  editTeamMemberModal = (id) => {
    this.setState({ keyModalTeamMember: `modalTeamMember_${new Date().getTime()}` });
    const item = this.state.incidentModel.investigationTeamMembers.find((el) => el.id == id);
    this.setState({
      editModelTeamMember: item,
      isEditModalTeamMember: true,
      isOpenModalTeamMember: true,
    });
  };

  handleTeamMemberSaveModal = (data) => {
    try {
      if (data == null) return;

      const oldTeamMemberPeople = this.state.incidentModel.investigationTeamMembers || [];

      if (this.state.isEditModalTeamMember) {
        // edit
        const { id } = data;
        const indexElement = oldTeamMemberPeople.findIndex((el) => el.id == id);
        if (indexElement > -1) {
          const newTeamMemberPeople = [...oldTeamMemberPeople];
          newTeamMemberPeople[indexElement] = data;
          this.updateState('investigationTeamMembers', newTeamMemberPeople, 'incidentModel');
        } else {
          showNotification.error();
        }
      } else {
        // insert
        data.idIncident = this.props.incidentEditModel.id;
        data.id = uuid(); // id InvestigationTeamMember
        if (data.idEmployer == null) {
          data.employer = null;
        }
        const newTeamMemberPeople = oldTeamMemberPeople.concat([data]);
        this.updateState('investigationTeamMembers', newTeamMemberPeople, 'incidentModel');
      }

      this.setState({ isOpenModalTeamMember: false });
    } catch (error) {
      showNotification.error();
    }
  };

  confirmTeamMemberDelete = (id) => {
    this.setState({
      idToDelete: null,
      idToDeleteWitness: null,
      idToDeleteTeamMember: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  deleteItemTeamMember = () => {
    const id = this.state.idToDeleteTeamMember;
    this.setState({
      isDeleting: true,
    });

    const statusCopy = { ...this.state.incidentModel };
    statusCopy.investigationTeamMembers = statusCopy.investigationTeamMembers.filter(
      (el) => el.id !== id
    );

    this.setState({
      incidentModel: statusCopy,
      isDeleting: false,
      isOpenDeleteModal: false,
    });
  };

  /** ************Fine TeamMember********************* */
  /** ************Attachment********************* */
  addNewAttachment = (data) => {
    try {
      if (data == null) return;
      // insert
      const oldattachment = this.state.incidentModel.attachment || [];

      const newItem = {
        id: uuid(), // guid
        idIncident: this.props.incidentEditModel.id,
        idAttachment: data.id, // guid
        attachment: data,
      };

      const newattachment = oldattachment.concat([newItem]);
      this.updateState('attachment', newattachment, 'incidentModel');
    } catch (error) {
      showNotification.error();
    }
  };

  removeAttachment = (id) => {
    if (!id) return;

    const statusCopy = { ...this.state.incidentModel };
    statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);

    this.setState({
      incidentModel: statusCopy,
    });
  };

  updateAutoOpenInjuredPersonTI = (value) => {
    this.props.updateAutoOpenInjuredPerson(false);
  }; 

  /** ************Fine Attachment********************* */
  render() {
    //RITM0864430
    if (this.props.autoInjuredPersonModal && !this.state.isInNewInjuredPerson) {
      this.addNewPerson();
      this.setState({isInNewInjuredPerson: true});
    }

    let injPersonsComplete = true;
    if (this.props.outcomeHarm && this.props.realOutcomeHarm){
    for (var i = 0; i < this.state.incidentModel.injuredPeople.length; i++) {
      const item = this.state.incidentModel.injuredPeople[i];
      if (item.nationality === null || item.idContractType === null || item.employmentDate === null ||
          item.prjJoiningDate === null || item.experienceYears === null || item.experienceMonths === null ||
          item.idShiftDuration === null || item.daysFromShiftStart === null || item.hoursFromShiftStart === null ||
          item.drugAlchoolTest === null || item.injuryRecurrent === null || item.idInjurySource === null ||
          item.idInjuryClass === null  || item.incidentInjuredPersonBodyPart?.length == 0)
          {
            injPersonsComplete = false;
            break;
          }      
    }
  }
    if(injPersonsComplete != this.state.isInjuredPersonsComplete) {this.setState({isInjuredPersonsComplete: injPersonsComplete});}

    this.validator.purgeFields(); // si usa quando ci sono validazioni condizionali tra più campi

    if (!this.props.incidentEditModel || !this.props.incidentEditModel.id) {
      return null;
    }

    const rowsEvents = this.state.incidentModel.incidentEvents || [];
    const rowsWitness = this.state.incidentModel.witnessPeople || [];
    const rowsTeamMember = this.state.incidentModel.investigationTeamMembers || [];
    const incidentEventModalProps = {
      key: this.state.keyModal,
      title: 'Event',
      editModel: this.state.editModel,
      isOpenModal: this.state.isOpenModal,
      isEditModal: this.state.isEditModal,
      toggleModal: this.toggleEventModal,
      save: this.handleEventSaveModal,
    };

    const getNameById = (id) => {
      if (id == null) return '';
      const element = rowsEvents.find((el) => el.id == id);
      return element ? element.briefDescription : '';
    };

    const confirmDelProps = () => {
      if (this.state.idToDeleteWitness) {
        return {
          idToDelete: this.state.idToDeleteWitness,
          nameItem: getNameWitnessById(this.state.idToDeleteWitness),
          isDeleting: this.state.isDeleting,
          open: this.state.isOpenDeleteModal, // open state
          onCloseConfirm: this.onCloseConfirm, // no click
          deleteItem: this.deleteItemWitness, // yes click fn()
        };
      }
      if (this.state.idToDeleteTeamMember) {
        return {
          idToDelete: this.state.idToDeleteTeamMember,
          nameItem: getNameTeamMemberById(this.state.idToDeleteTeamMember),
          isDeleting: this.state.isDeleting,
          open: this.state.isOpenDeleteModal, // open state
          onCloseConfirm: this.onCloseConfirm, // no click
          deleteItem: this.deleteItemTeamMember, // yes click fn()
        };
      }
      if (this.state.idInjurePerson) {
        return {
          idToDelete: this.state.idInjurePerson,
          nameItem: getNameTeamMemberById(this.state.idInjurePerson),
          isDeleting: this.state.isDeleting,
          open: this.state.isOpenDeleteModal, // open state
          onCloseConfirm: this.onCloseConfirm, // no click
          deleteItem: this.deleteItemInjuredPerson, // yes click fn()
        };
      }
      // default
      // if (this.state.idToDelete) {
      return {
        idToDelete: this.state.idToDelete,
        nameItem: getNameById(this.state.idToDelete),
        isDeleting: this.state.isDeleting,
        open: this.state.isOpenDeleteModal, // open state
        onCloseConfirm: this.onCloseConfirm, // no click
        deleteItem: this.deleteItem, // yes click fn()
      };
    };

    const incidentWitnessModalProps = {
      key: this.state.keyModalWitness,
      appType: this.props.appType,
      title: 'Witness',
      editModel: this.state.editModelWitness,
      isOpenModal: this.state.isOpenModalWitness,
      isEditModal: this.state.isEditModalWitness,
      mode: this.state.isEditModalWitness ? 2 : 0,
      toggleModal: this.toggleWitnessModal,
      save: this.handleWitnessSaveModal,
    };

    const getNameWitnessById = (id) => {
      if (id == null) return '';
      const element = rowsWitness.find((el) => el.id == id);
      return element && element.involvedPerson ? element.involvedPerson.fullname : '';
    };

    const incidentTeamMemberModalProps = {
      key: this.state.keyModalTeamMember,
      appType: this.props.appType,
      title: 'TeamMember',
      editModel: this.state.editModelTeamMember,
      isOpenModal: this.state.isOpenModalTeamMember,
      isEditModal: this.state.isEditModalTeamMember,
      mode: this.state.isEditModalTeamMember ? 2 : 0,
      toggleModal: this.toggleTeamMemberModal,
      save: this.handleTeamMemberSaveModal,
    };
    const rows = this.state.incidentModel.injuredPeople || [];
    const injuredPersonModalProps = {
      key: this.state.keyModal,
      title: 'Injured Person',
      editModel: this.state.editModelIJ,
      isOpenModal: this.state.isOpenModalIJ,
      isEditModal: this.state.isEditModalIJ,
      // mode: this.state.isEditModalIJ ? 2 : 0,
      //CR RITM0583314
      mode: 2,
      appType: this.props.appType,
      subContractors: this.props.subContractors,
      appNationality: this.props.appCountry,
      appInjuryType: this.props.appInjuryType,
      appContractType: this.state.appContractType,
      appShiftDuration: this.state.appShiftDuration,
      appInjurySource: this.state.appInjurySource,
      appInjuryClass: this.state.appInjuryClass,
      appBodyPart: this.state.appBodyPart,
      toggleModal: this.toggleModal,
      save: this.handleSaveModal,
      autoInjuredPersonModalFromNotification: this.props.autoInjuredPersonModal,
      updateAutoOpenInjuredPersonTI: this.updateAutoOpenInjuredPersonTI,
      updateHarmedPeople: this.props.updateHarmedPeople,
    };

    const getNameTeamMemberById = (id) => {
      if (id == null) return '';
      const element = rowsTeamMember.find((el) => el.id == id);
      return element && element.involvedPerson ? element.involvedPerson.fullname : '';
    };

    const appMeasureUnitForSpill = (this.state.appMeasureUnit || []).filter(
      (el) => el.usedInSpill == true
    );

    const appMeasureUnitForAirPollution = (this.state.appMeasureUnit || []).filter(
      (el) => el.usedInAirPollution == true
    );

    const selectedItemCombo = {
      sourceAccident: (this.state.appAccidentSource || []).find(
        (el) => el.id == this.state.incidentModel.sourceAccident
      ),
      spillLakeUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.spillLakeUM
      ),
      spillRiverUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.spillRiverUM
      ),
      spillSeaUM: appMeasureUnitForSpill.find((el) => el.id == this.state.incidentModel.spillSeaUM),
      spillSoilUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.spillSoilUM
      ),
      spillContainedUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.spillContainedUM
      ),
      airPollUM: appMeasureUnitForAirPollution.find(
        (el) => el.id == this.state.incidentModel.airPollUM
      ),
      uncontrolledReleaseLakeUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.uncontrolledReleaseLakeUM
      ),
      uncontrolledReleaseRiverUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.uncontrolledReleaseRiverUM
      ),
      uncontrolledReleaseSeaUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.uncontrolledReleaseSeaUM
      ),
      uncontrolledReleaseSoilUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.uncontrolledReleaseSoilUM
      ),
      uncontrolledReleaseContainedUM: appMeasureUnitForSpill.find(
        (el) => el.id == this.state.incidentModel.uncontrolledReleaseContainedUM
      ),
      idWorkProcessType: (this.state.appWorkProcessType || []).find(
        (el) => el.id == this.state.incidentModel.idWorkProcessType
      ),
      idWorkProcess: (this.state.appWorkProcess || []).find(
        (el) => el.id == this.state.incidentModel.idWorkProcess
      ),
      idWorkAreaType: (this.state.appWorkAreaType || []).find(
        (el) => el.id == this.state.incidentModel.idWorkAreaType
      ),
      idWorkArea: (this.state.appWorkArea || []).find(
        (el) => el.id == this.state.incidentModel.idWorkArea
      ),
      idEquipmentType: (this.state.appEquipmentType || []).find(
        (el) => el.id == this.state.incidentModel.idEquipmentType
      ),
      idEquipment: (this.state.appEquipment || []).find(
        (el) => el.id == this.state.incidentModel.idEquipment
      ),
      idAssetDamageType: (this.state.assetdamagetype || []).find(
        (el) => el.id == this.state.incidentModel.idAssetDamageType
      ),
    };

    // ---AT BUG 2844
    const showOtherWorkArea = selectedItemCombo.idWorkArea?.specifyOther;
    const showOtherWorkProcess = selectedItemCombo.idWorkProcess?.specifyOther;
    const showOtherEquipment = selectedItemCombo.idEquipment?.specifyOther;
    //---

    const tempIsValid =
      (!this.state.incidentModel.temperature && !this.state.incidentModel.temperatureType) ||
      (parseInt(this.state.incidentModel.temperature) >= 0
        ? this.state.incidentModel.temperatureType == 'Hot'
        : this.state.incidentModel.temperatureType == 'Cold');

    const validations = {
      // immediateActions: this.validator.message('immediateActions', this.state.hocCardModel.immediateActions, 'required'),

      // idWorkProcessType: this.validator.message('workProcessType', this.state.incidentModel.idWorkProcessType, 'required'),
      // idWorkProcess: this.validator.message('workProcess', this.state.incidentModel.idWorkProcess, 'required'),
      idWorkAreaType: this.validator.message(
        'workAreaType',
        this.state.incidentModel.idWorkAreaType,
        'required'
      ),
      idWorkArea: this.validator.message(
        'workArea',
        this.state.incidentModel.idWorkArea,
        'required'
      ),
      specifyOtherWorkArea: showOtherWorkArea
        ? this.validator.message(
            'specifyOtherWorkArea',
            this.state.incidentModel.specifyOtherWorkArea,
            'required'
          )
        : null,
      specifyOtherWorkProcess: showOtherWorkProcess
        ? this.validator.message(
            'specifyOtherWorkProcess',
            this.state.incidentModel.specifyOtherWorkProcess,
            'required'
          )
        : null,
      specifyOtherEquipment: showOtherEquipment
        ? this.validator.message(
            'specifyOtherEquipment',
            this.state.incidentModel.specifyOtherEquipment,
            'required'
          )
        : null,
      // idEquipmentType: this.validator.message('equipmentType', this.state.incidentModel.idEquipmentType, 'required'),
      // idEquipment: this.validator.message('equipment', this.state.incidentModel.idEquipment, 'required'),
      noWitness: this.validator.message(
        'noWitness',
        this.state.incidentModel.noWitness,
        'required'
      ),
      witnessPeople: !this.state.incidentModel.noWitness
        ? this.validator.message(
            'witnessPeople',
            this.state.incidentModel.witnessPeople,
            'required'
          )
        : null,
      incidentEvents: this.validator.message(
        'incidentEvents',
        this.state.incidentModel.incidentEvents,
        'required'
      ),
      investigationTeamMembers: this.validator.message(
        'investigationTeamMembers',
        this.state.incidentModel.investigationTeamMembers,
        'required'
      ),
      // attachment: this.validator.message(
      //   'attachment',
      //   this.state.incidentModel.attachment,
      //   'required'
      // ),
      temperatureHot: this.validator.message('temperature', tempIsValid, 'accepted'),
      sourceAccident: this.validator.message(
        'sourceAccident',
        this.props.outcomeEnviroment == true && this.state.incidentModel.sourceAccident,
        'required'
      ),
      airPollution: this.validator.message(
        'airPollution',
        this.state.incidentModel.isAirPollutio == true &&
          this.state.incidentModel.airPollQuantityReleased &&
          this.state.incidentModel.airPollSubstanceReleased &&
          this.state.incidentModel.airPollUM,
        'required'
      ),
      spillContainedNumericValue: this.validator.message(
        'Lake, River, Sea, Soil or Contained Spill',
        this.state.incidentModel.isSpill == true &&
        (this.state.incidentModel.spillContainedNumericValue || this.state.incidentModel.spillRiverNumericValue || this.state.incidentModel.spillLakeNumericValue || this.state.incidentModel.spillSeaNumericValue || this.state.incidentModel.spillSoilNumericValue),
        'required'
      ),
      spillSubstanceReleased: this.validator.message(
        'Spill Substance Released',
        this.state.incidentModel.isSpill == true &&
          this.state.incidentModel.spillSubstanceReleased,
        'required'
      ),
      uncontrolledReleaseContained: this.validator.message(
        'Lake, River, Sea, Soil or Contained',
        this.state.incidentModel.isUncontrolledRelease == true &&
        (this.state.incidentModel.uncontrolledReleaseContainedNumericValue || this.state.incidentModel.uncontrolledReleaseLakeNumericValue || this.state.incidentModel.uncontrolledReleaseRiverNumericValue || this.state.incidentModel.uncontrolledReleaseSeaNumericValue || this.state.incidentModel.uncontrolledReleaseSoilNumericValue),
        'required'
      ),
      uncontrolledReleaseSubstanceReleased: this.validator.message(
        'UncontrolledRelease Substance Released',
        this.state.incidentModel.isUncontrolledRelease == true &&
          this.state.incidentModel.uncontrolledReleaseSubstanceReleased,
        'required'
      ),
      floraFaunaDamageImpactOn: this.validator.message(
        'Flora/fauna damage Impact on',
        this.state.incidentModel.isFloraFaunaDamage == true && this.state.incidentModel.impactOn,
        'required'
      ),
      floraFaunaDamageSpeciesAffected: this.validator.message(
        'Flora/fauna damage Species Affected',
        this.state.incidentModel.isFloraFaunaDamage == true &&
        this.state.incidentModel.floraFaunaDamageSpeciesAffected,
        'required'
      ),
      noInjured: this.validator.message(
        'noInjured',
        this.state.incidentModel.noInjured
          ? this.state.incidentModel.noInjured
          : !this.props.realOutcomeHarm,
        'required'
      ),
      injuredPeople:
        this.props.isAccident || this.state.incidentModel.noInjured == false
          ? this.validator.message(
              'injuredPeople',
              this.state.incidentModel.injuredPeople,
              'required'
            )
          : null,
      idAssetDamageType: this.validator.message(
        'idAssetDamageType',
        this.props.outcomeAsset == true && this.state.incidentModel.idAssetDamageType,
        'required'
      ),
    };

    return (
      <>
        <ConfirmAlertCustom {...confirmDelProps()} />
        <div className="bx--row">
          <div className="padding-progress-indicator-vertical hidden-box">
            <Menu>
              {this.props.outcomeHarm ? (
                <Item section="personnelinjuries">2.1 Injured Personnel details</Item>
              ) : (
                ''
              )}

              {this.props.outcomeAsset ? (
                <Item section="propertyassetdamage">2.2 Asset Damage details</Item>
              ) : (
                ''
              )}

              {this.props.outcomeEnviroment ? (
                <Item section="environment">2.3 Environmental damage detail</Item>
              ) : (
                ''
              )}

              <Item section="timeline">2.4 Time line</Item>
              <Item section="other">2.5 Other information</Item>
              <Item section="Weather">2.6 Weather Conditions</Item>
              <Item section="witness">2.7 Witnesses</Item>
              <Item section="investteam">2.8 Investigation Team</Item>
              <Item section="attachment">2.9 Attachment Section</Item>
              {/* <Item section="investfind">3.8 Investigation Findings</Item> */}
            </Menu>
          </div>
          <div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
            {(this.props.outcomeHarm && this.props.realOutcomeHarm)? (
              <Section id="personnelinjuries" className="section--title">
                <div>
                  <h3 className="title--medium--expressive">2.1 Injured Personnel details</h3>
                </div>
                <div className="bx--row section--title">
                  <div className="bx--col-lg-12 no-margin-fieldset">
                    <FormGroup legendText="Are there any injured? (*)">
                      <RadioButtonGroup
                        labelPosition="right"
                        legend=""
                        name="noInjured"
                        onChange={this.handleChangeRadio}
                        orientation="horizontal"
                        valueSelected={
                          this.state.incidentModel.noInjured != null
                            ? this.state.incidentModel.noInjured.toString()
                            : (!this.props.realOutcomeHarm)?.toString()
                        }
                      >
                        <RadioButton
                          id="niYes"
                          key={`${(!this.props.realOutcomeHarm)?.toString()}_niYes`}
                          value="false"
                          labelText="Yes"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                        <RadioButton
                          id="niNo"
                          key={`${(!this.props.realOutcomeHarm)?.toString()}_niNo`}
                          value="true"
                          labelText="No"
                          alt="incidentModel"
                          disabled={this.state.isDisabled || (rows && rows.length > 0)}
                        />
                      </RadioButtonGroup>
                      {validations.noInjured}
                    </FormGroup>
                  </div>
                </div>
                <div className="bx--row">
                  <div className="bx--col-lg-12">
                    <TableToolbar>
                      <h3 className="title--medium max-width" />
                      {!this.state.isDisabled && !this.state.incidentModel.noInjured && (
                        <Button onClick={() => this.addNewPerson()} renderIcon={Add16}>
                          Add new
                        </Button>
                      )}
                    </TableToolbar>

                    <TableContainer className="bx--grid--full-width">
                      <Table>
                        <TableHead className="colorgray">
                          <TableRow>
                          <TableHeader>Injured Person Type</TableHeader>
                            {/* <TableHeader>Badge Number</TableHeader> */}
                            <TableHeader>Type of Injury</TableHeader>
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length == 0 ? (
                            <NoRecordsPlaceholder labelText="No Records" colSpan={4} />
                          ) : (
                            rows.map((item, index) => (
                              <TableRow key={`row_${item.id}`}>
                                <TableCell key={`cell_type_${item.id}`}>
                                  {item.type}
                                </TableCell>
                                {/* <TableCell key={`cell_badgeNumber_${item.id}`}>
                                  {item.badgeNumber}
                                </TableCell> */}
                                <TableCell key={`cell_idInjuryType_${item.id}`}>
                                  {this.getInjuryTypeName(item.idInjuryType)}
                                </TableCell>
                                <TableCell
                                  key={`action-${item.id}`}
                                  className="tableActions align-center"
                                >
                                  {!this.state.isDisabled && (
                                    <div>
                                      {/* (IsInRole(this.props.user, "Administrator") || item.toSave) &&
                                                                        <Button onClick={() => this.editModal(item.id)} size="small" renderIcon={Edit16} iconDescription="Edit" kind="ghost" />
                                                                    */}
                                      <Button
                                        onClick={() => this.editModal(item.id)}
                                        size="small"
                                        renderIcon={Edit16}
                                        iconDescription="Edit"
                                        kind="ghost"
                                      />
                                      <Button
                                        onClick={() => this.confirmDeleteInjPerson(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                      />
                                    </div>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                      {validations.injuredPeople}
                    </TableContainer>
                  </div>
                </div>
                <InjuredPersonModal {...injuredPersonModalProps} />
              </Section>
            ) : (
              ''
            )}
            {this.props.outcomeAsset ? (
              <Section id="propertyassetdamage" className="section--title section">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">2.2 Asset Damage details</h3>
                </div>
                <div className="bx--row section--title">
                  <div className="bx--col-lg-6 bx--col-md-4 section--title">
                    <FormGroup legendText="Asset Damage type(*)">
                      <ComboBox
                        key={`idAssetDamageType${selectedItemCombo.idAssetDamageType}`}
                        id="idAssetDamageType"
                        placeholder="Select"
                        name="idAssetDamageType"
                        alt="incidentModel"
                        onChange={this.handleChangeCombo}
                        itemToString={(item) => (item ? item.name : '')}
                        initialSelectedItem={selectedItemCombo.idAssetDamageType}
                        items={this.state.assetdamagetype}
                        invalid={validations.idAssetDamageType != null}
                        disabled={this.state.isDisabled}
                      />
                      {validations.idAssetDamageType}
                    </FormGroup>
                    <FormGroup legendText="Certification">
                      <RadioButtonGroup
                        labelPosition="right"
                        legend=""
                        name="certification"
                        onChange={this.handleChangeRadio}
                        orientation="horizontal"
                        valueSelected={
                          this.state.incidentModel.certification != null
                            ? this.state.incidentModel.certification.toString()
                            : ''
                        }
                      >
                        <RadioButton
                          id="certificationYes"
                          value="true"
                          labelText="Yes"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                        <RadioButton
                          id="certificationNo"
                          value="false"
                          labelText="No"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                      </RadioButtonGroup>
                      <div className="table--role">
                        <TextInput
                          id="number"
                          name="number"
                          alt="incidentModel"
                          placeholder=" Input Certification Number"
                          value={this.state.incidentModel.number || ''}
                          onChange={this.handleChangeModel}
                          type="text"
                          disabled={
                            this.state.incidentModel.certification == null ||
                            this.state.isDisabled ||
                            this.state.incidentModel.certification != true
                          }
                          labelText=""
                        />
                      </div>
                    </FormGroup>
                    <FormGroup legendText="Safety Devices removed?">
                      <RadioButtonGroup
                        labelPosition="right"
                        legend=""
                        name="safetyDevicesRemoved"
                        onChange={this.handleChangeRadio}
                        orientation="horizontal"
                        valueSelected={
                          this.state.incidentModel.safetyDevicesRemoved != null
                            ? this.state.incidentModel.safetyDevicesRemoved.toString()
                            : ''
                        }
                      >
                        <RadioButton
                          id="safetyDeviceRemovedYes"
                          value="true"
                          labelText="Yes"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                        <RadioButton
                          id="safetyDeviceRemovedNo"
                          value="false"
                          labelText="No"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                      </RadioButtonGroup>
                      <div className="table--role">
                        <TextInput
                          id="specify"
                          name="specify"
                          alt="incidentModel"
                          placeholder="Input Removed Devices"
                          value={this.state.incidentModel.specify || ''}
                          onChange={this.handleChangeModel}
                          type="text"
                          disabled={
                            this.state.incidentModel.safetyDevicesRemoved == null ||
                            this.state.isDisabled ||
                            this.state.incidentModel.safetyDevicesRemoved != true
                          }
                          labelText=""
                        />
                      </div>
                    </FormGroup>
                  </div>
                  <div className="bx--col-lg-6 bx--col-md-4 section--title">
                    <FormGroup legendText="Asset Tag number">
                      <TextInput
                        id="assetTagNumber"
                        name="assetTagNumber"
                        alt="incidentModel"
                        placeholder="Input Asset Tag Number"
                        value={this.state.incidentModel.assetTagNumber || ''}
                        onChange={this.handleChangeModel}
                        type="text"
                        // disabled={this.state.incidentModel.spillLakeUM == null || this.state.isDisabled  || this.state.incidentModel.isSpill != true}
                        labelText=""
                      />
                      {validations.workRelated}
                    </FormGroup>
                    <FormGroup legendText="Last date of inspection: ">
                      <DateTimePicker
                        value={this.state.incidentModel.lastDateInspection}
                        type="date"
                        placeholder={DateFormat}
                        name="lastDateInspection"
                        alt="incidentModel"
                        invalid={validations.lastDateInspection != null}
                        onChange={this.updateStateDP}
                        disabled={this.state.isDisabled}
                      />
                    </FormGroup>
                    <FormGroup legendText="Safety Critical Equipment">
                      <RadioButtonGroup
                        labelPosition="right"
                        legend=""
                        name="safetyCriticalEquipment"
                        onChange={this.handleChangeRadio}
                        orientation="horizontal"
                        valueSelected={
                          this.state.incidentModel.safetyCriticalEquipment != null
                            ? this.state.incidentModel.safetyCriticalEquipment.toString()
                            : ''
                        }
                      >
                        <RadioButton
                          id="safetyCritialYes"
                          value="true"
                          labelText="Yes"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                        <RadioButton
                          id="safetyCritialNo"
                          value="false"
                          labelText="No"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                      </RadioButtonGroup>
                    </FormGroup>
                    <FormGroup legendText="Is the asset covered by a Computerized Maintenance Management System (CMMS)?">
                      <RadioButtonGroup
                        labelPosition="right"
                        legend=""
                        name="cmms"
                        onChange={this.handleChangeRadio}
                        orientation="horizontal"
                        valueSelected={
                          this.state.incidentModel.cmms != null
                            ? this.state.incidentModel.cmms.toString()
                            : ''
                        }
                      >
                        <RadioButton
                          id="cMMSYes"
                          value="true"
                          labelText="Yes"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                        <RadioButton
                          id="cMMSNo"
                          value="false"
                          labelText="No"
                          alt="incidentModel"
                          disabled={this.state.isDisabled}
                        />
                      </RadioButtonGroup>
                    </FormGroup>
                  </div>
                </div>
              </Section>
            ) : (
              ''
            )}
            {this.props.outcomeEnviroment ? (
              <Section id="environment" className="section--title section">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">2.3 Environmental damage detail</h3>
                </div>
                <div className="bx--col-lg-12 ">
                  <Accordion className="accordion-option section--title">
                    <AccordionItem title="Source of Accident*" open={false}>
                      <FormGroup legendText="">
                        <div className="bx--col-lg-4 bx--col-md-4">
                          <ComboBox
                            key={`sourceAccidentl_${selectedItemCombo.sourceAccident}`}
                            id="sourceAccident"
                            placeholder="Select"
                            name="sourceAccident"
                            alt="incidentModel"
                            onChange={this.handleChangeCombo}
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItem={selectedItemCombo.sourceAccident}
                            items={this.state.appAccidentSource}
                            disabled={this.state.appAccidentSource == null || this.state.isDisabled}
                            invalid={validations.sourceAccident != null}
                          />
                          {validations.sourceAccident}
                        </div>
                      </FormGroup>
                    </AccordionItem>
                    <AccordionItem title="Spill" open={false}>
                      <div className="bx--row">
                        <div className="bx--col-lg-12 bx--col-md-12 ">
                          <FormGroup legendText="">
                            <Checkbox
                              id="nwSpill"
                              alt="incidentModel"
                              labelText="Spill"
                              checked={this.state.incidentModel.isSpill || false}
                              onChange={(el) => this.updateState('isSpill', el, 'incidentModel')}
                              disabled={this.state.isDisabled}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <FormGroup legendText="">
                        <div className="bx--row">
                          <div className="bx--col-lg-3 bx--col-md-4 ">
                            <FormLabel>Lake</FormLabel>
                            <ComboBox
                              key={`spillLakeUM_${selectedItemCombo.spillLakeUM}`}
                              id="spillLakeUM"
                              placeholder="Select"
                              name="spillLakeUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.spillLakeUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true || selectedItemCombo.spillContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="spillLakeNumericValue"
                              name="spillLakeNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={this.state.incidentModel.spillLakeNumericValue || ''}
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.spillLakeUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true
                              }
                              labelText=""
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>River</FormLabel>
                            <ComboBox
                              key={`spillRiverUM_${selectedItemCombo.spillRiverUM}`}
                              id="spillRiverUM"
                              placeholder="Select"
                              name="spillRiverUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.spillRiverUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true || selectedItemCombo.spillContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="spillRiverNumericValue"
                              name="spillRiverNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={this.state.incidentModel.spillRiverNumericValue || ''}
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.spillRiverUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true
                              }
                              labelText=""
                            />
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup legendText="">
                        <div className="bx--row">
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>Sea</FormLabel>
                            <ComboBox
                              key={`spillSeaUM_${selectedItemCombo.spillSeaUM}`}
                              id="spillSeaUM"
                              placeholder="Select"
                              name="spillSeaUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.spillSeaUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true || selectedItemCombo.spillContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="spillSeaNumericValue"
                              name="spillSeaNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={this.state.incidentModel.spillSeaNumericValue || ''}
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.spillSeaUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true
                              }
                              labelText=""
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>Soil</FormLabel>
                            <ComboBox
                              key={`spillSoilUM${selectedItemCombo.spillSoilUM}`}
                              id="spillSoilUM"
                              placeholder="Select"
                              name="spillSoilUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.spillSoilUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true || selectedItemCombo.spillContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="spillSoilNumericValue"
                              name="spillSoilNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={this.state.incidentModel.spillSoilNumericValue || ''}
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.spillSoilUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true
                              }
                              labelText=""
                            />
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup legendText="">
                        <div className="bx--row">
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>Contained</FormLabel>
                            <ComboBox
                              key={`spillContainedUM_${selectedItemCombo.spillContainedUM}`}
                              id="spillContainedUM"
                              placeholder="Select"
                              name="spillContainedUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.spillContainedUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="spillContainedNumericValue"
                              name="spillContainedNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={this.state.incidentModel.spillContainedNumericValue || ''}
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.spillContainedUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isSpill != true
                              }
                              labelText=""
                            />
                          </div>
                        </div>
                      </FormGroup>                      
                    {validations.spillContainedNumericValue}
                      <div className="bx--row">
                        <div className="bx--col-lg-12">
                          <FormLabel>Substance released*</FormLabel>
                          <ComboBox
                            key={`spillSubstanceReleased_${selectedItemCombo.spillContainedUM}`}
                            id="spillSubstanceReleased"
                            placeholder="Select"
                            name="spillSubstanceReleased"
                            alt="incidentModel"
                            onChange={this.handleChangeCombo}
                            //itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItem={this.state.incidentModel.spillSubstanceReleased}
                            items={this.state.substanceReleased}
                            disabled={
                              this.state.isDisabled || this.state.incidentModel.isSpill != true
                            }
                          />
                          {validations.spillSubstanceReleased}
                        </div>
                      </div>
                      <div className="bx--row row-content section--title">
                        <div className="bx--col-lg-12 ">
                          <FormGroup legendText="Description">
                            <TextArea
                              maxLength={5000}
                              id="spillDescription"
                              placeholder="Brief description of Immediate Actions Taken to contain/stop the spill"
                              value={this.state.incidentModel.spillDescription || ''}
                              onChange={(el) =>
                                this.updateState(
                                  'spillDescription',
                                  el.target.value,
                                  'incidentModel'
                                )
                              }
                              hideLabel
                              labelText=""
                              light
                              rows={4}
                              cols={100}
                              disabled={this.state.isDisabled}
                            />
                          </FormGroup>
                        </div>
                      </div>

                      <div className="bx--row">
                        <div className="bx--col-lg-6 bx--col-md-4">
                          <FormGroup legendText="Was there any spill kit used?">
                            <Toggle
                              id="isUsedSpillKit"
                              aria-label=""
                              labelText=""
                              labelA="No"
                              labelB="Yes"
                              toggled={this.state.incidentModel.isUsedSpillKit || false}
                              onToggle={this.handleToggle}
                              disabled={this.state.isDisabled}
                            />
                          </FormGroup>
                        </div>
                        <div className="bx--col-lg-6 bx--col-md-4">
                          <FormGroup legendText="Was there any procedure in place?">
                            <Toggle
                              id="isInPlaceProcedure"
                              aria-label=""
                              labelText=""
                              labelA="No"
                              labelB="Yes"
                              toggled={this.state.incidentModel.isInPlaceProcedure || false}
                              onToggle={this.handleToggle}
                              disabled={this.state.isDisabled}
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </AccordionItem>
                    <AccordionItem title="Uncontrolled release into the environment" open={false}>
                      <div className="bx--row">
                        <div className="bx--col-lg-12 bx--col-md-12 ">
                          <FormGroup legendText="">
                            <Checkbox
                              id="nwUncontrolledRelease"
                              alt="incidentModel"
                              labelText="Uncontrolled release into the environment"
                              checked={this.state.incidentModel.isUncontrolledRelease || false}
                              onChange={(el) =>
                                this.updateState('isUncontrolledRelease', el, 'incidentModel')
                              }
                              disabled={this.state.isDisabled}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <FormGroup legendText="">
                        <div className="bx--row">
                          <div className="bx--col-lg-3 bx--col-md-4 ">
                            <FormLabel>Lake</FormLabel>
                            <ComboBox
                              key={`UncontrolledReleaseLakeUM_${selectedItemCombo.uncontrolledReleaseLakeUM}`}
                              id="uncontrolledReleaseLakeUM"
                              placeholder="Select"
                              name="uncontrolledReleaseLakeUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.uncontrolledReleaseLakeUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true || selectedItemCombo.uncontrolledReleaseContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="uncontrolledReleaseLakeNumericValue"
                              name="uncontrolledReleaseLakeNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={
                                this.state.incidentModel.uncontrolledReleaseLakeNumericValue || ''
                              }
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.uncontrolledReleaseLakeUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true
                              }
                              labelText=""
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>River</FormLabel>
                            <ComboBox
                              key={`uncontrolledReleaseRiverUM_${selectedItemCombo.uncontrolledReleaseRiverUM}`}
                              id="uncontrolledReleaseRiverUM"
                              placeholder="Select"
                              name="uncontrolledReleaseRiverUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.uncontrolledReleaseRiverUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true || selectedItemCombo.uncontrolledReleaseContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="uncontrolledReleaseRiverNumericValue"
                              name="uncontrolledReleaseRiverNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={
                                this.state.incidentModel.uncontrolledReleaseRiverNumericValue || ''
                              }
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.uncontrolledReleaseRiverUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true
                              }
                              labelText=""
                            />
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup legendText="">
                        <div className="bx--row">
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>Sea</FormLabel>
                            <ComboBox
                              key={`uncontrolledReleaseSeaUM_${selectedItemCombo.uncontrolledReleaseSeaUM}`}
                              id="uncontrolledReleaseSeaUM"
                              placeholder="Select"
                              name="uncontrolledReleaseSeaUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.uncontrolledReleaseSeaUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true || selectedItemCombo.uncontrolledReleaseContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="uncontrolledReleaseSeaNumericValue"
                              name="uncontrolledReleaseSeaNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={
                                this.state.incidentModel.uncontrolledReleaseSeaNumericValue || ''
                              }
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.uncontrolledReleaseSeaUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true
                              }
                              labelText=""
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>Soil</FormLabel>
                            <ComboBox
                              key={`uncontrolledReleaseSoilUM${selectedItemCombo.uncontrolledReleaseSoilUM}`}
                              id="uncontrolledReleaseSoilUM"
                              placeholder="Select"
                              name="uncontrolledReleaseSoilUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.uncontrolledReleaseSoilUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true || selectedItemCombo.uncontrolledReleaseContainedUM
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="uncontrolledReleaseSoilNumericValue"
                              name="uncontrolledReleaseSoilNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={
                                this.state.incidentModel.uncontrolledReleaseSoilNumericValue || ''
                              }
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.uncontrolledReleaseSoilUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true 
                              }
                              labelText=""
                            />
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup legendText="">
                        <div className="bx--row">
                          <div className="bx--col-lg-3 bx--col-md-4">
                            <FormLabel>Contained</FormLabel>
                            <ComboBox
                              key={`uncontrolledReleaseContainedUM_${selectedItemCombo.uncontrolledReleaseContainedUM}`}
                              id="uncontrolledReleaseContainedUM"
                              placeholder="Select"
                              name="uncontrolledReleaseContainedUM"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={selectedItemCombo.uncontrolledReleaseContainedUM}
                              items={appMeasureUnitForSpill}
                              disabled={
                                appMeasureUnitForSpill == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true
                              }
                            />
                          </div>
                          <div className="bx--col-lg-3 bx--col-md-4 section-text ">
                            <TextInput
                              id="uncontrolledReleaseContainedNumericValue"
                              name="uncontrolledReleaseContainedNumericValue"
                              alt="incidentModel"
                              placeholder=""
                              value={
                                this.state.incidentModel.uncontrolledReleaseContainedNumericValue ||
                                ''
                              }
                              onChange={this.handleChangeModel}
                              type="number"
                              disabled={
                                this.state.incidentModel.uncontrolledReleaseContainedUM == null ||
                                this.state.isDisabled ||
                                this.state.incidentModel.isUncontrolledRelease != true
                              }
                              labelText=""
                            />
                          </div>
                        </div>
                      </FormGroup>
                      {validations.uncontrolledReleaseContained}
                      <div className="bx--row">
                        <div className="bx--col-lg-12">
                          <FormLabel>Substance released*</FormLabel>
                          <TextInput
                            id="uncontrolledReleaseSubstanceReleased"
                            name="uncontrolledReleaseSubstanceReleased"
                            alt="incidentModel"
                            placeholder=""
                            value={
                              this.state.incidentModel.uncontrolledReleaseSubstanceReleased || ''
                            }
                            onChange={this.handleChangeModel}
                            type="text"
                            labelText=""
                            disabled={
                              this.state.isDisabled ||
                              this.state.incidentModel.isUncontrolledRelease != true
                            }
                          />
                          {validations.uncontrolledReleaseSubstanceReleased}
                        </div>
                      </div>
                    </AccordionItem>
                    <AccordionItem title="Air Pollution">
                      <div className="bx--row">
                        <FormGroup legendText="">
                          <Checkbox
                            id="nwAirPollution"
                            alt="incidentModel"
                            labelText="Air Pollution"
                            checked={this.state.incidentModel.isAirPollutio || false}
                            onChange={(el) =>
                              this.updateState('isAirPollutio', el, 'incidentModel')
                            }
                            disabled={this.state.isDisabled}
                          />
                        </FormGroup>
                        <div className="bx--col-lg-12">
                          <FormLabel>
                            Substances Released
                            {this.state.incidentModel.isAirPollutio == true ? '*' : null}
                          </FormLabel>
                          <TextInput
                            id="airPollSubstanceReleased"
                            name="airPollSubstanceReleased"
                            alt="incidentModel"
                            placeholder=""
                            value={this.state.incidentModel.airPollSubstanceReleased || ''}
                            onChange={this.handleChangeModel}
                            type="text"
                            labelText=""
                            disabled={
                              this.state.isDisabled ||
                              this.state.incidentModel.isAirPollutio != true
                            }
                            invalid={validations.airPollution}
                          />
                        </div>
                      </div>
                      <div className="bx--row section--title">
                        <div className="bx--col-lg-6 bx--col-md-4">
                          <FormLabel>
                            Estimated Release Quantity
                            {this.state.incidentModel.isAirPollutio == true ? '*' : null}
                          </FormLabel>
                          <ComboBox
                            key={`airPollUM_${selectedItemCombo.airPollUM}`}
                            id="airPollUM"
                            placeholder="Select"
                            name="airPollUM"
                            alt="incidentModel"
                            onChange={this.handleChangeCombo}
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItem={selectedItemCombo.airPollUM}
                            items={appMeasureUnitForAirPollution}
                            disabled={
                              appMeasureUnitForAirPollution == null ||
                              this.state.isDisabled ||
                              this.state.incidentModel.isAirPollutio != true
                            }
                            invalid={validations.airPollution}
                          />
                        </div>
                        <div className="bx--col-lg-6 bx--col-md-4 section-text">
                          <TextInput
                            id="airPollQuantityReleased"
                            name="airPollQuantityReleased"
                            alt="incidentModel"
                            placeholder=""
                            value={this.state.incidentModel.airPollQuantityReleased || ''}
                            onChange={this.handleChangeModel}
                            type="number"
                            disabled={
                              this.state.incidentModel.airPollUM == null ||
                              this.state.isDisabled ||
                              this.state.incidentModel.isAirPollutio != true
                            }
                            labelText=""
                            invalid={validations.airPollution}
                          />
                        </div>
                      </div>

                      {validations.airPollution}
                    </AccordionItem>
                    <AccordionItem title="Flora/Fauna damage">
                      <div className="bx--row">
                        <div className="bx--col-lg-12">
                          <FormGroup legendText="">
                            <Checkbox
                              id="nwFloraFaunaDamage"
                              alt="incidentModel"
                              labelText="Flora/Fauna damage"
                              checked={this.state.incidentModel.isFloraFaunaDamage || false}
                              onChange={(el) =>
                                this.updateState('isFloraFaunaDamage', el, 'incidentModel')
                              }
                              disabled={this.state.isDisabled}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-lg-4 bx--col-md-4">
                          <FormGroup 
                          legendText={'Impact on' + (this.state.incidentModel.isFloraFaunaDamage ? '*' : '')}>
                            <ComboBox
                              key={`impacton${this.state.incidentModel.impactOn}`}
                              id="impactOn"
                              placeholder="Select"
                              name="impactOn"
                              alt="incidentModel"
                              onChange={this.handleChangeCombo}
                              //itemToString={(item) => (item ? item.name : '')}
                              initialSelectedItem={this.state.incidentModel.impactOn}
                              items={this.state.impactOn}
                              disabled={
                                this.state.isDisabled ||
                                this.state.incidentModel.isFloraFaunaDamage != true
                              }
                            />
                            {validations.floraFaunaDamageImpactOn}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-lg-12">   
                        <FormLabel>Species affected{(this.state.incidentModel.isFloraFaunaDamage ? '*' : '')}</FormLabel>
                          <TextInput
                            id="floraFaunaDamageSpeciesAffected"
                            name="floraFaunaDamageSpeciesAffected"
                            alt="incidentModel"
                            placeholder=""
                            value={this.state.incidentModel.floraFaunaDamageSpeciesAffected || ''}
                            onChange={this.handleChangeModel}
                            type="text"
                            labelText=""
                            disabled={
                              this.state.isDisabled ||
                              this.state.incidentModel.isFloraFaunaDamage != true
                            }
                          />
                          {validations.floraFaunaDamageSpeciesAffected}
                        </div>
                      </div>
                      <div className="bx--row row-content section--title">
                        <div className="bx--col-lg-12 ">
                          <FormGroup legendText="Description">
                            <TextArea
                              maxLength={5000}
                              id="floraFaunaDamageDescription"
                              placeholder=""
                              value={this.state.incidentModel.floraFaunaDamageDescription || ''}
                              onChange={(el) =>
                                this.updateState(
                                  'floraFaunaDamageDescription',
                                  el.target.value,
                                  'incidentModel'
                                )
                              }
                              hideLabel
                              labelText=""
                              light
                              rows={4}
                              cols={100}
                              disabled={
                                this.state.isDisabled ||
                                this.state.incidentModel.isFloraFaunaDamage != true
                              }
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </AccordionItem>
                    <AccordionItem title="Other">
                      <div className="bx--row">
                        <div className="bx--col-lg-12">
                          <FormGroup legendText="">
                            <Checkbox
                              id="nwOther"
                              alt="incidentModel"
                              labelText="Other"
                              checked={this.state.incidentModel.isOther || false}
                              onChange={(el) => this.updateState('isOther', el, 'incidentModel')}
                              disabled={this.state.isDisabled}
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-lg-12">
                          <FormGroup legendText="Description">
                            <TextArea
                              maxLength={5000}
                              id="otherDescription"
                              placeholder=""
                              value={this.state.incidentModel.otherDescription || ''}
                              onChange={(el) =>
                                this.updateState(
                                  'otherDescription',
                                  el.target.value,
                                  'incidentModel'
                                )
                              }
                              hideLabel
                              labelText=""
                              light
                              rows={4}
                              cols={100}
                              disabled={
                                this.state.isDisabled || this.state.incidentModel.isOther != true
                              }
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </AccordionItem>
                  </Accordion>
                </div>
              </Section>
            ) : (
              ''
            )}

            {validations.sourceAccident}
            <Section id="timeline">
              <div>
                {' '}
                <h3 className="title--medium--expressive">2.4 Time line (*)</h3>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-12">
                  <TableToolbar>
                    <h3 className="title--medium max-width" />
                    {!this.state.isDisabled && (
                      <Button
                        onClick={() => {
                          this.addNewEvent();
                        }}
                        renderIcon={Add16}
                      >
                        Add new
                      </Button>
                    )}
                  </TableToolbar>
                  <TableContainer className="bx--grid--full-width">
                    <Table>
                      <TableHead className="colorgray">
                        <TableRow>
                          <TableHeader>Date/Time</TableHeader>
                          <TableHeader className="align-center">Anomaly</TableHeader>
                          <TableHeader>Description</TableHeader>
                          <TableHeader className="align-center">Actions</TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rowsEvents == null || rowsEvents.length == 0 ? (
                          <NoRecordsPlaceholder labelText="No Records" colSpan={4} />
                        ) : (
                          rowsEvents
                            .sort(
                              (a, b) =>
                                new Date(a.occurredAt).getTime() - new Date(b.occurredAt).getTime()
                            )
                            .map((item, index) => (
                              <TableRow key={`row_${item.id}`}>
                                <TableCell key={`cell_occurredAt_${item.id}`}>
                                  {switchDateFormat(item.occurredAt, 'datetime')}
                                </TableCell>
                                <TableCell key={`cell_anomaly_${item.id}`} className="align-center">
                                  {item.anomaly && (
                                    <Checkmark24 fill="#1A3E4C" aria-label="Anomaly" />
                                  )}
                                </TableCell>
                                <TableCell key={`cell_briefDescription_${item.id}`}>
                                  {item.briefDescription}
                                </TableCell>
                                <TableCell
                                  key={`action-${item.id}`}
                                  className="tableActions align-center"
                                >
                                  {!this.state.isDisabled && (
                                    <div>
                                      <Button
                                        onClick={() => this.editEventModal(item.id)}
                                        size="small"
                                        renderIcon={Edit16}
                                        iconDescription="Edit"
                                        kind="ghost"
                                      />
                                      <Button
                                        onClick={() => this.confirmDelete(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                      />
                                    </div>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
              <IncidentEventModal {...incidentEventModalProps} />
              <div className="error-validation-message">{validations.incidentEvents}</div>
            </Section>
            <Section id="other">
              <div>
                {' '}
                <h3 className="title--medium--expressive section--title">2.5 Other information</h3>
              </div>
              <div className="bx--row section--title">
                <div className="bx--col-lg-4 bx--col-md-4">
                  <FormLabel> Work process Type</FormLabel>
                </div>
                <div className="bx--col-lg-8 bx--col-md-4">
                  <FormLabel> Work process</FormLabel>
                </div>
              </div>
              <div className="bx--row ">
                <div className="bx--col-lg-4 bx--col-md-4">
                  {!this.state.appWorkProcessType ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      key={`idWorkProcessType_${selectedItemCombo.idWorkProcessType}`}
                      id="idWorkProcessType"
                      placeholder="Select"
                      name="idWorkProcessType"
                      alt="incidentModel"
                      onChange={this.handleChangeComboType}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={selectedItemCombo.idWorkProcessType}
                      items={this.state.appWorkProcessType}
                      // invalid={validations.idWorkProcessType != null}
                      disabled={this.state.isDisabled}
                    />
                  )}
                </div>
                <div className="bx--col-lg-4 bx--col-md-4">
                  <ComboBox
                    id="idWorkProcess"
                    placeholder="Select"
                    name="idWorkProcess"
                    alt="incidentModel"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.idWorkProcess || '-'}
                    items={this.state.appWorkProcess}
                    // invalid={validations.idWorkProcess != null}
                    disabled={this.state.appWorkProcess == null || this.state.isDisabled}
                  />
                </div>
                {showOtherWorkProcess && (
                  <div className="bx--col-lg-4 bx--col-md-4">
                    <TextInput
                      key={`idWorkProcess${selectedItemCombo.idWorkProcess}`}
                      id="specifyOtherWorkProcess"
                      name="specifyOtherWorkProcess"
                      alt="incidentModel"
                      placeholder="Specify other..."
                      value={this.state.incidentModel.specifyOtherWorkProcess || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      labelText="Specify other*"
                      hideLabel="true"
                      disabled={this.state.isDisabled}
                      invalid={validations.specifyOtherWorkProcess != null}
                    />
                    {validations.specifyOtherWorkProcess}
                  </div>
                )}
              </div>
              <div className="bx--row section--title">
                <div className="bx--col-lg-4 bx--col-md-4">
                  <FormLabel> Work Area Type (*)</FormLabel>
                </div>
                <div className="bx--col-lg-4 bx--col-md-4">
                  <FormLabel> Work Area (*)</FormLabel>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-4 bx--col-md-4">
                  {!this.state.appWorkAreaType ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      key={`idWorkAreaType${selectedItemCombo.idWorkAreaType}`}
                      id="idWorkAreaType"
                      placeholder="Select"
                      name="idWorkAreaType"
                      alt="incidentModel"
                      onChange={this.handleChangeComboType}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={selectedItemCombo.idWorkAreaType}
                      items={this.state.appWorkAreaType}
                      invalid={validations.idWorkAreaType != null}
                      disabled={this.state.isDisabled}
                    />
                  )}
                  {validations.idWorkAreaType}
                </div>
                <div className="bx--col-lg-4 bx--col-md-4">
                  <ComboBox
                    key={`idWorkArea${selectedItemCombo.idWorkArea}`}
                    id="idWorkArea"
                    placeholder="Select"
                    name="idWorkArea"
                    alt="incidentModel"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.idWorkArea || '-'}
                    items={this.state.appWorkArea}
                    invalid={validations.idWorkArea != null}
                    disabled={this.state.appWorkArea == null || this.state.isDisabled}
                  />
                  {validations.idWorkArea}
                </div>
                {showOtherWorkArea && (
                  <div className="bx--col-lg-4 bx--col-md-4">
                    <TextInput
                      id="specifyOtherWorkArea"
                      name="specifyOtherWorkArea"
                      alt="incidentModel"
                      placeholder="Specify other..."
                      value={this.state.incidentModel.specifyOtherWorkArea || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      labelText="Specify other*"
                      hideLabel="true"
                      disabled={this.state.isDisabled}
                      invalid={validations.specifyOtherWorkArea != null}
                    />
                    {validations.specifyOtherWorkArea}
                  </div>
                )}
              </div>
              <div className="bx--row section--title">
                <div className="bx--col-lg-4 bx--col-md-4">
                  <FormLabel> Equipment Type</FormLabel>
                </div>
                <div className="bx--col-lg-4 bx--col-md-4">
                  <FormLabel> Equipment</FormLabel>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-4 bx--col-md-4">
                  {!this.state.appEquipmentType ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      key={`idEquipmentType${selectedItemCombo.idEquipmentType}`}
                      id="idEquipmentType"
                      placeholder="Select"
                      name="idEquipmentType"
                      alt="incidentModel"
                      onChange={this.handleChangeComboType}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={selectedItemCombo.idEquipmentType}
                      items={this.state.appEquipmentType}
                      // invalid={validations.idEquipmentType != null}
                      disabled={this.state.isDisabled}
                    />
                  )}
                </div>
                <div className="bx--col-lg-4 bx--col-md-4">
                  <ComboBox
                    key={`idEquipment${selectedItemCombo.idEquipment}`}
                    id="idEquipment"
                    placeholder="Select"
                    name="idEquipment"
                    alt="incidentModel"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.idEquipment}
                    items={this.state.appEquipment}
                    // invalid={validations.idEquipment != null}
                    disabled={this.state.appEquipment == null || this.state.isDisabled}
                  />
                </div>
                {showOtherEquipment && (
                  <div className="bx--col-lg-4 bx--col-md-4">
                    <TextInput
                      id="specifyOtherEquipment"
                      name="specifyOtherEquipment"
                      alt="incidentModel"
                      placeholder="Specify other..."
                      value={this.state.incidentModel.specifyOtherEquipment || ''}
                      onChange={this.handleChangeModel}
                      type="text"
                      labelText="Specify other*"
                      hideLabel="true"
                      disabled={this.state.isDisabled}
                      invalid={validations.specifyOtherEquipment != null}
                    />
                    {validations.specifyOtherEquipment}
                  </div>
                )}
              </div>
            </Section>
            <Section id="Weather">
              <div className="bx--row section--title">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">2.6 Weather Conditions</h3>
                </div>
              </div>
              <div className="bx--row section--title">
                <div className="bx--col-lg-3 bx--col-md-3  ">
                  <FormGroup legendText="Light">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="light"
                      onChange={this.handleChangeRadio}
                      orientation="vertical"
                      valueSelected={this.state.incidentModel.light}
                    >
                      <RadioButton
                        id="lightGood"
                        key="lightGood"
                        name="light"
                        value="Good"
                        labelText="Good"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                      <RadioButton
                        id="lightFair"
                        key="lightFair"
                        name="light"
                        value="Fair"
                        labelText="Fair"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                      <RadioButton
                        id="lightPoor"
                        key="lightPoor"
                        name="light"
                        value="Poor"
                        labelText="Poor"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                    </RadioButtonGroup>
                  </FormGroup>
                </div>
                <div className="bx--col-lg-3 bx--col-md-3">
                  <FormGroup legendText="Light origin">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="lightOrigin"
                      onChange={this.handleChangeRadio}
                      orientation="vertical"
                      valueSelected={this.state.incidentModel.lightOrigin}
                    >
                      <RadioButton
                        id="lightOrigin1"
                        key="lightOrigin1"
                        name="lightOrigin"
                        value="Natural"
                        labelText="Natural"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                      <RadioButton
                        id="lightOrigin2"
                        key="lightOrigin2"
                        name="lightOrigin"
                        value="Artificial"
                        labelText="Artificial"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                    </RadioButtonGroup>
                  </FormGroup>
                </div>
                <div className="bx--col-lg-3 bx--col-md-3">
                  <FormGroup legendText="Weather">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="wheather"
                      onChange={this.handleChangeRadio}
                      orientation="vertical"
                      valueSelected={this.state.incidentModel.wheather}
                    >
                      <RadioButton
                        id="Weather1"
                        key="Weather1"
                        name="wheather"
                        value="Dry"
                        labelText="Dry"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                      <RadioButton
                        id="Weather2"
                        key="Weather2"
                        name="wheather"
                        value="Wet"
                        labelText="Wet"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                      <RadioButton
                        id="Weather3"
                        key="Weather3"
                        name="wheather"
                        value="Ice"
                        labelText="Ice"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                      <RadioButton
                        id="Weather4"
                        key="Weather4"
                        name="wheather"
                        value="Fog"
                        labelText="Fog"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                    </RadioButtonGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-4 bx--col-md-4">
                  <FormGroup legendText="Sea">
                    <ComboBox
                      id="sea"
                      placeholder="Select"
                      name="sea"
                      alt="incidentModel"
                      onChange={(name, value, alt) =>
                        this.updateState('sea', value, 'incidentModel')
                      }
                      itemToString={(item) => item || ''}
                      initialSelectedItem={this.state.incidentModel.sea}
                      items={this.state.appSea}
                      disabled={this.state.isDisabled}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-4 bx--col-md-4">
                  <FormGroup legendText="Temperature (°C)">
                    <TextInput
                      id="temperature"
                      name="temperature"
                      alt="incidentModel"
                      placeholder=""
                      value={this.state.incidentModel.temperature || ''}
                      onChange={this.handleChangeModel}
                      type="number"
                      labelText=""
                      invalid={validations.temperatureHot != null}
                      disabled={this.state.isDisabled}
                    />
                    {validations.temperatureHot ? (
                      <div className="srv-validation-message">
                        {' '}
                        The temperature must be consistent with the type: Hot or Cold{' '}
                      </div>
                    ) : null}
                  </FormGroup>
                </div>
                <div className="bx--col-lg-4 bx--col-md-3 section-text">
                  <RadioButtonGroup
                    labelPosition="right"
                    legend=""
                    name="temperatureType"
                    onChange={this.handleChangeRadio}
                    orientation="horizontal"
                    valueSelected={this.state.incidentModel.temperatureType}
                  >
                    <RadioButton
                      id="temperatureType1"
                      key="temperatureType1"
                      name="temperatureType"
                      value="Hot"
                      labelText="Hot"
                      alt="incidentModel"
                      disabled={this.state.isDisabled}
                    />
                    <RadioButton
                      id="temperatureType2"
                      key="temperatureType2"
                      name="temperatureType"
                      value="Cold"
                      labelText="Cold"
                      alt="incidentModel"
                      disabled={this.state.isDisabled}
                    />
                  </RadioButtonGroup>
                </div>
              </div>

              <div className="bx--row">
                <div className="bx--col-lg-4">
                  <FormGroup legendText="Wind Speed (Knot)">
                    <TextInput
                      id="windSpeed"
                      name="windSpeed"
                      alt="incidentModel"
                      placeholder=""
                      value={this.state.incidentModel.windSpeed || ''}
                      onChange={this.handleChangeModel}
                      type="number"
                      labelText=""
                      disabled={this.state.isDisabled}
                    />
                  </FormGroup>
                </div>
              </div>
            </Section>
            <Section id="witness">
              <div className="bx--row">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">2.7 Witnesses (*)</h3>
                </div>
              </div>
              <div className="bx--row section--title">
                <div className="bx--col-lg-12 no-margin-fieldset">
                  <FormGroup legendText="Are there any witnesses?">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="noWitness"
                      onChange={this.handleChangeRadio}
                      orientation="horizontal"
                      valueSelected={
                        this.state.incidentModel.noWitness != null
                          ? this.state.incidentModel.noWitness.toString()
                          : ''
                      }
                    >
                      <RadioButton
                        id="nwYes"
                        value="false"
                        labelText="Yes"
                        alt="incidentModel"
                        disabled={this.state.isDisabled}
                      />
                      <RadioButton
                        id="nwNo"
                        value="true"
                        labelText="No"
                        alt="incidentModel"
                        disabled={this.state.isDisabled || (rowsWitness && rowsWitness.length > 0)}
                      />
                    </RadioButtonGroup>
                    {validations.noWitness}
                  </FormGroup>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-12">
                  <TableToolbar>
                    <h3 className="title--medium max-width" />
                    {!this.state.isDisabled && !this.state.incidentModel.noWitness && (
                      <Button
                        onClick={() => {
                          this.addWitness();
                        }}
                        renderIcon={Add16}
                      >
                        Add new
                      </Button>
                    )}
                  </TableToolbar>
                  <TableContainer className="bx--grid--full-width">
                    <Table>
                      <TableHead className="colorgray">
                        <TableRow>
                          <TableHeader>Type</TableHeader>
                          <TableHeader>Full Name</TableHeader>
                          {/* Removed in RITM0701238 */}
                          {/* <TableHeader>National ID (CF)</TableHeader> */}
                          <TableHeader className="align-center">Witness statement</TableHeader>
                          <TableHeader className="align-center">Actions</TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rowsWitness == null || rowsWitness.length == 0 ? (
                          <NoRecordsPlaceholder labelText="No Records" colSpan={5} />
                        ) : (
                          rowsWitness.map((item, index) => (
                            <TableRow key={`row_${item.id}`}>
                              <TableCell key={`cell_type_${item.id}`}>
                                {item.involvedPerson.type}
                              </TableCell>
                              <TableCell key={`cell_fullname_${item.id}`}>
                                {item.involvedPerson.fullname}
                              </TableCell>
                              {/* Removed in RITM0701238 */}
                              {/* <TableCell key={`cell_nationalID_${item.id}`}>
                                {item.involvedPerson.nationalID}
                              </TableCell> */}
                              <TableCell key={`cell_statement_${item.id}`} className="align-center">
                                {item.witnessStatement && (
                                  <Checkmark24 fill="#1A3E4C" aria-label="Witness Statement" />
                                )}
                              </TableCell>
                              <TableCell
                                key={`action-${item.id}`}
                                className="tableActions align-center"
                              >
                                {!this.state.isDisabled && (
                                  <div>
                                    <Button
                                      onClick={() => this.editWitnessModal(item.id)}
                                      size="small"
                                      renderIcon={Edit16}
                                      iconDescription="Edit"
                                      kind="ghost"
                                    />
                                    <Button
                                      onClick={() => this.confirmWitnessDelete(item.id)}
                                      size="small"
                                      renderIcon={Delete16}
                                      iconDescription="Delete"
                                      kind="ghost"
                                    />
                                  </div>
                                )}
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
              <WitnessPeopleModal {...incidentWitnessModalProps} />
              <div className="error-validation-message">{validations.witnessPeople}</div>
            </Section>
            <Section id="investteam">
              <div className="bx--row section--title">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">2.8 Investigation Team (*)</h3>
                </div>
              </div>
              <div className="bx--row ">
                <div className="bx--col-lg-12">
                  <TableToolbar>
                    <h3 className="title--medium max-width" />
                    {!this.state.isDisabled && (
                      <Button
                        onClick={() => {
                          this.addTeamMember();
                        }}
                        renderIcon={Add16}
                      >
                        Add new
                      </Button>
                    )}
                  </TableToolbar>
                  <TableContainer className="bx--grid--full-width">
                    <Table>
                      <TableHead className="colorgray">
                        <TableRow>
                          <TableHeader>Name</TableHeader>
                          <TableHeader>Surname</TableHeader>
                          <TableHeader>Badge Number</TableHeader>
                          <TableHeader>Email</TableHeader>
                          <TableHeader className="align-center">Team Leader</TableHeader>
                          <TableHeader className="align-center">Actions</TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rowsTeamMember == null || rowsTeamMember.length == 0 ? (
                          <NoRecordsPlaceholder labelText="No Records" colSpan={6} />
                        ) : (
                          rowsTeamMember.map((item, index) => (
                            <TableRow key={`row_${item.id}`}>
                              <TableCell key={`cell_name_${item.id}`}>
                                {item.name != null
                                  ? item.name
                                  : item.employer
                                  ? item.employer.name
                                  : ''}
                              </TableCell>
                              <TableCell key={`cell_surname_${item.id}`}>
                                {item.surname != null
                                  ? item.surname
                                  : item.employer
                                  ? item.employer.surname
                                  : ''}
                              </TableCell>
                              <TableCell key={`cell_badgeNumber_${item.id}`}>
                                {item.ghrS_ID != null
                                  ? item.ghrS_ID
                                  : item.employer
                                  ? item.employer.ghrS_ID
                                  : ''}
                              </TableCell>
                              <TableCell key={`cell_email_${item.id}`}>
                                {item.email != null
                                  ? item.email
                                  : item.employer
                                  ? item.employer.email
                                  : ''}
                              </TableCell>
                              <TableCell
                                key={`cell_isTeamLeader_${item.id}`}
                                className="align-center"
                              >
                                {item.isTeamLeader && (
                                  <Checkmark24 fill="#1A3E4C" aria-label="Is Team Leader" />
                                )}
                              </TableCell>
                              <TableCell
                                key={`action-${item.id}`}
                                className="tableActions align-center"
                              >
                                {!this.state.isDisabled && (
                                  <div>
                                    <Button
                                      onClick={() => this.editTeamMemberModal(item.id)}
                                      size="small"
                                      renderIcon={Edit16}
                                      iconDescription="Edit"
                                      kind="ghost"
                                    />
                                    <Button
                                      onClick={() => this.confirmTeamMemberDelete(item.id)}
                                      size="small"
                                      renderIcon={Delete16}
                                      iconDescription="Delete"
                                      kind="ghost"
                                    />
                                  </div>
                                )}
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
              <TeamMemberModal {...incidentTeamMemberModalProps} />
              <div className="error-validation-message">{validations.investigationTeamMembers}</div>
            </Section>
            <Section id="attachment" className="table-section-action">
              <div className="bx--row section--title">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">2.9 Attachment Section</h3>
                  <h6>(It is prohibited to add in the report / notification any sensitive picture (i.e. wound, stitches, broken part, etc..) or any sensitive information related to the injured person.​
                    It is also forbidden to upload photos on which it is possible to recognize specific people​)</h6>
                </div>
              </div>

              <IncidentAttachment
                attachments={this.state.incidentModel.attachment}
                addNewAttachment={this.addNewAttachment}
                removeAttachment={this.removeAttachment}
                isDisabled={this.state.isDisabled}
                idIncident={this.state.incidentModel.id}
              />

              {/* <div className="error-validation-message">{validations.attachment}</div> */}
            </Section>
            {/* <Section id="investfind">
                        <div style={{ paddingTop: 30 }}><h3 className="title--medium--expressive">3.8 Investigation Findings</h3></div>

                        <div className="bx--row row-content " >
                            <div className="bx--col-lg-12 bx--col-md-12">
                                <FormGroup legendText="Detailed description of critical factors found during investigation ">
                                    <TextArea
                                    maxLength={5000}
                                        id="investigationCriticalFactors"
                                        placeholder="Input detailed description"
                                        value={this.state.incidentModel.investigationCriticalFactors || ''}
                                        onChange={(el) => this.updateState('investigationCriticalFactors', el.target.value, 'incidentModel')}
                                        hideLabel={true}
                                        labelText=""
                                        light
                                        rows={4}
                                        cols={100}
                                    />
                                </FormGroup>
                            </div>
                            <div className="bx--col-lg-12 bx--col-md-12">
                                <FormGroup legendText="Lesson Learned">
                                    <TextArea
                                    maxLength={5000}
                                        id="lessonLearned"
                                        placeholder="Input lesson learned"
                                        value={this.state.incidentModel.lessonLearned || ''}
                                        onChange={(el) => this.updateState('lessonLearned', el.target.value, 'incidentModel')}
                                        hideLabel={true}
                                        labelText=""
                                        light
                                        rows={4}
                                        cols={100}
                                    />
                                </FormGroup>
                            </div>
                        </div>
                    </Section> */}
          </div>
        </div>
        <div className="bx--row">
          <Button
            onClick={() => this.selectTab(0)}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Prev Step
          </Button>
          <Button
            onClick={() => this.props.cancel()}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => this.saveTabInvestigation()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="primary"
          >
            Save
          </Button>
          <Button
            onClick={() => window.print()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Print
          </Button>
          <Button
            onClick={() => this.selectTab(2)}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Next Step
          </Button>
        </div> 
      </>
    );
  }
}
